
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 22","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.298 4h-11.9V1.9l6.3-.7 5.6.7V4z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.298 20.1h-11.9V18l6.3-.7 5.6.7v2.1z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.333 2a.764.764 0 00-.777.75v.75h10.888v-.75a.764.764 0 00-.777-.75H2.333zM14 2.75C14 1.507 12.955.5 11.667.5H2.333C1.045.5 0 1.507 0 2.75v16.5c0 1.243 1.045 2.25 2.333 2.25h9.334c1.288 0 2.333-1.007 2.333-2.25V2.75zM12.444 5H1.556v12h10.888V5zm0 13.5H1.556v.75c0 .414.348.75.777.75h9.334c.43 0 .777-.336.777-.75v-.75z","fill":"currentColor"}})])
          )
        }
      }
    